export default "__VITE_ASSET__BrRIjAVw__"